import { render, staticRenderFns } from "./DeleteKitModal.vue?vue&type=template&id=2ed35551&"
import script from "./DeleteKitModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteKitModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteKitModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports